<div class="inner-page-bg-right">
  <div *ngIf="displayTerms">

    <section class="banner-inner-pages">
      <div class="container">
        <div class="row-custom">
          <div class="col-sm-5-custom">
            <div class="banner-left-text">
              <h3 data-aos="fade-up" style="padding-bottom: 8px">Be Seen</h3>
              <h2 data-aos="fade-up" style="padding-bottom: 8px">Be Scanned</h2>
              <h1 data-aos="fade-up">Be Chosen</h1>
            </div>
          </div>
          <div class="col-sm-7-custom" data-aos="fade-up"> <img src="assets/crm_images/mobile-qr-codes-banner-img.png"
              alt=""> </div>
        </div>
      </div>
    </section>

<section class="smart-showcase">
      <div class="container">
        <div class="row-custom">
          <div class="col-sm-12-custom">
            <h3 data-aos="fade-up">And imagine this: This could be your site, live in minutes.</h3>
            <p data-aos="fade-up" data-aos-delay="120">Your customers will scan your QR code to access it — instantly.
            </p>
            <!-- <div class="crm_image_container">
              <div class="crm_slider">
                <div
                  class="crm_card_image"
                  *ngFor="let item of crm_images; let i = index"
                  data-aos="fade-up"
                  [attr.data-aos-delay]="i * 100"
                >
                  <img
                    [src]="'assets/icons/icon/' + item[0] + '.png'"
                    loading="lazy"
                    alt="{{ item[1] }}"
                  />
                  <span>{{ item[1] | titlecase }}</span>
                </div>
              </div>
            </div> -->
            <div class="carousel-viewport" (mouseenter)="pause()" (mouseleave)="resume()">

              <button class="nav-btn prev" (click)="movePrev()">&#10094;</button>

              <div class="crm_image_container">
                <div class="crm_slider" #sliderRef>
                  <div class="crm_card_image" *ngFor="let item of displayList" (mouseenter)="toggle(item)">
                    <!-- <img [src]="getIconPath(item[0])" [alt]="item[1]" *ngIf="!item[2]" />
                    <qrcode *ngIf="item[2]" [qrdata]="getQrUrl(item[0])" [width]="160"[errorCorrectionLevel]="'M'"></qrcode> -->
                    <div class="icon-qrcode-wrapper">
                      <img [src]="getIconPath(item[0])" [alt]="item[1]" [class.visible]="!item[2]" />

                      <qrcode [qrdata]="getQrUrl(item)" [width]="120" [errorCorrectionLevel]="'M'"
                        [class.visible]="item[2]"></qrcode>
                    </div>

                    <span>{{ item[1] | titlecase }}</span>
                  </div>
                </div>
              </div>

              <button class="nav-btn next" (click)="moveNext()">&#10095;</button>

            </div>

            <!-- <div class="showcase-carousel" data-aos="fade-up" data-aos-delay="200">
              <button class="showcase-nav prev" type="button" aria-label="Scroll showcase left"></button>



              <div class="showcase-track">

                <div class="showcase-card" *ngFor="let item of crm_images; let i = index" (click)="openSite(item[1])"
                  data-aos="fade-up" [attr.data-aos-delay]="i * 100">
                  <img [src]="'assets/icons/icon/' + item[0] + '.png'" loading="lazy" />
                  <span>{{ item[1] | titlecase }}</span>
                </div>


                <div class="showcase-card" data-aos="fade-up" data-aos-delay="0">
                  <img src="assets/crm_images/slider-img-1.png" alt="Retail Smart Site example" loading="lazy">
                  <span>Retail Experience</span>
                </div>
                <div class="showcase-card" data-aos="fade-up" data-aos-delay="60">
                  <img src="assets/crm_images/slider-img-2.png" alt="Restaurant Smart Site example" loading="lazy">
                  <span>Restaurant Story</span>
                </div>
                <div class="showcase-card" data-aos="fade-up" data-aos-delay="120">
                  <img src="assets/crm_images/slider-img-3.png" alt="Wellness Smart Site example" loading="lazy">
                  <span>Beauty &amp; Wellness</span>
                </div>
                <div class="showcase-card" data-aos="fade-up" data-aos-delay="180">
                  <img src="assets/crm_images/slider-img-1.png" alt="Fitness Smart Site example" loading="lazy">
                  <span>Fitness Studio</span>
                </div>
                <div class="showcase-card" data-aos="fade-up" data-aos-delay="240">
                  <img src="assets/crm_images/slider-img-2.png" alt="Event Smart Site example" loading="lazy">
                  <span>Pop-up Event</span>
                </div>
                <div class="showcase-card" data-aos="fade-up" data-aos-delay="300">
                  <img src="assets/crm_images/slider-img-3.png" alt="Real estate Smart Site example" loading="lazy">
                  <span>Real Estate Hub</span>
                </div>
                <div class="showcase-card" data-aos="fade-up" data-aos-delay="360">
                  <img src="assets/crm_images/slider-img-1.png" alt="Coffee shop Smart Site example" loading="lazy">
                  <span>Coffee Shop</span>
                </div>
                <div class="showcase-card" data-aos="fade-up" data-aos-delay="420">
                  <img src="assets/crm_images/slider-img-2.png" alt="Insurance Smart Site example" loading="lazy">
                  <span>Insurance Services</span>
                </div>
                <div class="showcase-card" data-aos="fade-up" data-aos-delay="480">
                  <img src="assets/crm_images/slider-img-3.png" alt="Travel agency Smart Site example" loading="lazy">
                  <span>Travel Agency</span>
                </div>
                <div class="showcase-card" data-aos="fade-up" data-aos-delay="540">
                  <img src="assets/crm_images/slider-img-1.png" alt="Automotive Smart Site example" loading="lazy">
                  <span>Automotive Care</span>
                </div>
                <div class="showcase-card" data-aos="fade-up" data-aos-delay="600">
                  <img src="assets/crm_images/slider-img-2.png" alt="Grocery Smart Site example" loading="lazy">
                  <span>Grocery Market</span>
                </div>
                <div class="showcase-card" data-aos="fade-up" data-aos-delay="660">
                  <img src="assets/crm_images/slider-img-3.png" alt="Clinic Smart Site example" loading="lazy">
                  <span>Health Clinic</span>
                </div>
                <div class="showcase-card" data-aos="fade-up" data-aos-delay="720">
                  <img src="assets/crm_images/slider-img-1.png" alt="Electronics Smart Site example" loading="lazy">
                  <span>Electronics Hub</span>
                </div>
                <div class="showcase-card" data-aos="fade-up" data-aos-delay="780">
                  <img src="assets/crm_images/slider-img-2.png" alt="Hospitality Smart Site example" loading="lazy">
                  <span>Hospitality Suite</span>
                </div>
                <div class="showcase-card" data-aos="fade-up" data-aos-delay="840">
                  <img src="assets/crm_images/slider-img-3.png" alt="Education Smart Site example" loading="lazy">
                  <span>Education Center</span>
                </div>
                <div class="showcase-card" data-aos="fade-up" data-aos-delay="900">
                  <img src="assets/crm_images/slider-img-1.png" alt="Home services Smart Site example" loading="lazy">
                  <span>Home Services</span>
                </div>
              </div>
              <button class="showcase-nav next" type="button" aria-label="Scroll showcase right"></button>
            </div> -->
          </div>
        </div>
      </div>
    </section>

    <section class="home-sec-1">
      <div class="container">
        <div class="row-custom">
          <div class="col-sm-12-custom">
            <h2 data-aos="fade-up" data-aos-delay="120" class="home-sec-1-heading">Turn Every Scan Into a Connection
            </h2>
            <p data-aos="fade-up" data-aos-delay="160">Your Smart Site draws them in. Your Smart Promo keeps them
              engaged. With Scanfluence, you're not just seen—you’re remembered</p>
            <div class="cta-group">
              <a class="btn-cmn" href="price.html" data-aos="fade-up" data-aos-delay="200">View Price Plan</a>
              <a class="btn-cmn" href="#contact" data-aos="fade-up" data-aos-delay="260">Book a Live Demo</a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="smart-visibility">
      <div class="container">
        <div class="row-custom">
          <div class="col-sm-12-custom">
            <h2 data-aos="fade-up">Smart Site</h2>
            <h4 class="section-tag" data-aos="fade-up" data-aos-delay="40">Instant Visibility. Connected Experience.
              Real Results.</h4>
            <p data-aos="fade-up" data-aos-delay="120">Your Smart Site isn’t just a microsite — it’s a connected
              business hub. From showcasing your products and services, to running Smart Promos, enabling mini-cart
              orders, bookings, and payments — all seamlessly connected with your POS and CRM.</p>
            <p class="bridge-line" data-aos="fade-up" data-aos-delay="200">Your QR-powered Smart Micro Sites unify your
              brand — connecting your website, social media, and physical stores into a single, seamless, connected
              experience.</p>
            <p data-aos="fade-up" data-aos-delay="260">With one dynamic QR, customers can explore your products, book
              appointments, claim offers, or make purchases — all from one sleek, mobile-ready page. Every action syncs
              automatically across your systems, giving you full visibility and control from your Scanfluence dashboard.
            </p>
            <div class="feature-highlights">
              <ul>
                <li data-aos="fade-up" data-aos-delay="0">Dynamic QR for Infinite Reach</li>
                <li data-aos="fade-up" data-aos-delay="80">Branded, Mobile-Optimized Design</li>
                <li data-aos="fade-up" data-aos-delay="140">Appointment Booking Made Simple</li>
                <li data-aos="fade-up" data-aos-delay="200">Built-In Mini Cart &amp; Payments</li>
                <li data-aos="fade-up" data-aos-delay="260">Real-Time Analytics</li>
                <li data-aos="fade-up" data-aos-delay="320">POS, CRM &amp; Online Platform Integration</li>
              </ul>
            </div>
            <div class="section-cta" data-aos="fade-up" data-aos-delay="380">
              <a class="btn-cmn" href="#contact">Book a Live Demo</a>
            </div>
            <div class="section-video" data-aos="fade-up" data-aos-delay="440">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/WeMvxGVgl98?si=TIbyz7pQn1E4i5Lt"
                title="Smart Site Experience Video" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="smart-promo">
      <div class="container">
        <div class="row-custom">
          <div class="col-sm-12-custom">
            <h2 data-aos="fade-up">Smart Promo</h2>
            <h4 class="section-tag" data-aos="fade-up" data-aos-delay="40">From First Scan to Lasting Loyalty.</h4>
            <p data-aos="fade-up" data-aos-delay="120">Smart Promo turns every interaction into a growth opportunity.
              Launch digital offers, loyalty rewards, and personalized campaigns that engage customers, drive repeat
              visits, and deliver measurable results — all powered by secure, real-time validation.</p>
            <p class="bridge-line" data-aos="fade-up" data-aos-delay="200">When your Smart Site attracts attention,
              Smart Promo turns that attention into action.</p>
            <div class="feature-highlights">
              <ul>
                <li data-aos="fade-up" data-aos-delay="0">Smart, Secure Offers</li>
                <li data-aos="fade-up" data-aos-delay="80">Personalized Engagement</li>
                <li data-aos="fade-up" data-aos-delay="140">Frequent Buyer Programs</li>
                <li data-aos="fade-up" data-aos-delay="200">Personalized Gift Cards</li>
                <li data-aos="fade-up" data-aos-delay="260">Gamified Promotions</li>
                <li data-aos="fade-up" data-aos-delay="320">Real-Time Validation &amp; Reporting</li>
              </ul>
            </div>
            <div class="section-cta" data-aos="fade-up" data-aos-delay="380">
              <a class="btn-cmn" href="#contact">Book a Live Demo</a>
            </div>
            <div class="section-video" data-aos="fade-up" data-aos-delay="440">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/OriLif2IDK4?si=muDher8vO3J4WG5B"
                title="Smart Promo Journey Video" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="connected-advantage">
      <div class="container">
        <div class="row-custom">
          <div class="col-sm-12-custom">
            <h2 data-aos="fade-up">Connected Advantage</h2>
            <h4 class="section-tag" data-aos="fade-up" data-aos-delay="40">One Platform. Total Connection. Infinite
              Possibilities.</h4>
            <p data-aos="fade-up" data-aos-delay="120">Your Smart Site is the heart of connected commerce — unifying
              Smart Promo, Shopping Cart, Booking, Website, and Social Media into one seamless experience. Fully
              integrated with Shopify, WooCommerce, and any POS or ERP system, Scanfluence keeps your business data,
              customer journeys, and performance metrics all in sync.</p>
            <div class="feature-highlights">
              <ul>
                <li data-aos="fade-up" data-aos-delay="0">Unified Commerce Framework</li>
                <li data-aos="fade-up" data-aos-delay="80">Integrates with Everything You Use</li>
                <li data-aos="fade-up" data-aos-delay="140">Business-Wide Sync</li>
                <li data-aos="fade-up" data-aos-delay="200">Multi-Channel Presence</li>
                <li data-aos="fade-up" data-aos-delay="260">Real-Time Insights</li>
              </ul>
            </div>
            <div class="section-cta" data-aos="fade-up" data-aos-delay="320">
              <a class="btn-cmn" href="#contact">Book a Live Demo</a>
            </div>
          </div>
        </div>
      </div>
    </section>






    <!-- Previous caraosel position -->


    <section class="smart-confidence">
      <div class="container">
        <div class="row-custom">
          <div class="col-sm-12-custom">
            <h2 data-aos="fade-up">Why Choose Scanfluence</h2>
            <h4 class="section-tag" data-aos="fade-up" data-aos-delay="40">Built for Confidence. Trusted for Growth.
            </h4>
            <p data-aos="fade-up" data-aos-delay="120">Businesses choose Scanfluence because it’s more than a platform —
              it’s a secure, data-driven ecosystem designed to scale with you.</p>
            <div class="feature-highlights">
              <ul>
                <li data-aos="fade-up" data-aos-delay="0">Fraud-Proof Validation</li>
                <li data-aos="fade-up" data-aos-delay="80">Plug-and-Play Integration</li>
                <li data-aos="fade-up" data-aos-delay="140">Real-Time Analytics</li>
                <li data-aos="fade-up" data-aos-delay="200">Multi-Channel Publishing</li>
                <li data-aos="fade-up" data-aos-delay="260">Scalable &amp; Future-Ready</li>
              </ul>
            </div>
            <div class="section-cta" data-aos="fade-up" data-aos-delay="320">
              <a class="btn-cmn" href="#contact">Book a Live Demo</a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="smart-growth">
      <div class="container">
        <div class="row-custom">
          <div class="col-sm-12-custom">
            <h2 data-aos="fade-up">Start Smart. Grow Smarter.</h2>
            <p data-aos="fade-up" data-aos-delay="120">Your journey to connected commerce begins with a single scan.
              Launch your Smart Site for instant visibility, power it with Smart Promo for repeat engagement, and
              connect it all with your POS, CRM, and online platforms through Scanfluence.</p>
            <p data-aos="fade-up" data-aos-delay="200">Scanfluence gives you everything you need to turn discovery into
              loyalty — all in one platform. Whether you’re a retailer, franchise, or brand, you can now engage
              customers across every touchpoint — online, offline, and everywhere in between — while gaining the
              real-time visibility and control you’ve always wanted.</p>
          </div>
        </div>
      </div>
    </section>
    <section class="home-sec-7">
      <div class="container">
        <div class="row-custom">
          <div class="col-sm-12-custom">
            <div class="how-it-works-top-home">
              <h2 data-aos="fade-up">How it <span>works?</span></h2>
              <p data-aos="fade-up">In just a few simple steps, users can launch multiple campaigns instantly and manage
                the entire life cycle on the go</p>
            </div>

            <div class="how-it-work-home-inner">

              <div class="how-it-work-text-img text-img-1" data-aos="fade-left">
                <div class="img-hiw">
                  <img src="assets/crm_images/how-it-works-ste-1.png" alt="">
                </div>
                <div class="how-it-work-text">
                  <h3>Step 1 Create</h3>
                  <p>Customize your campaigns in few clicks</p>
                </div>
              </div>

              <div class="how-it-work-text-img text-img-2" data-aos="fade-left">
                <div class="img-hiw">
                  <img src="assets/crm_images/how-it-works-ste-2.png" alt="">
                </div>
                <div class="how-it-work-text">
                  <h3>Step 2 Publish</h3>
                  <p>Post Links, Banners & QR codes in digital channels</p>
                </div>
              </div>

              <div class="how-it-work-text-img text-img-3" data-aos="fade-left">
                <div class="img-hiw">
                  <img src="assets/crm_images/how-it-works-ste-3.png" alt="">
                </div>
                <div class="how-it-work-text">
                  <h3>Step 3 Notify</h3>
                  <p>Send announcements to participating stores</p>
                </div>
              </div>


              <div class="how-it-work-text-img text-img-4" data-aos="fade-left">
                <div class="img-hiw">
                  <img src="assets/crm_images/how-it-works-ste-4.png" alt="">
                </div>
                <div class="how-it-work-text">
                  <h3>Step 4 Redeem</h3>
                  <p>Validating Coupons are secured & quick</p>
                </div>
              </div>

              <div class="how-it-work-text-img text-img-5" data-aos="fade-left">
                <div class="img-hiw">
                  <img src="assets/crm_images/how-it-works-ste-5.png" alt="">
                </div>
                <div class="how-it-work-text">
                  <h3>Step 5 Track</h3>
                  <p>Gain real time visibility, See stats & measure ROI</p>
                </div>
              </div>

              <div class="how-it-work-text-img text-img-6" data-aos="fade-left">
                <div class="img-hiw">
                  <img src="assets/crm_images/how-it-works-ste-6.png" alt="">
                </div>
                <div class="how-it-work-text">
                  <h3>Step 6 Reconcile</h3>
                  <p>It’s automated. Say goodbye to lengthy processes</p>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </section>


  </div>
  <div *ngIf="!displayTerms">
    <app-crm-terms></app-crm-terms>
  </div>
  <footer class="footer-bg-main">
    <div class="container">
      <div class="row-custom">
        <div class="col-sm-4-custom">
          <div class="footer-left" data-aos="flip-right">
            <a href="#"><img src="images/logo-inner.png" alt=""></a>
            <p>Scanfluence: Simplifying Coupons, Maximizing Results.</p>
            <ul>
              <li><a href="#"><i class="fa-brands fa-facebook-f" aria-hidden="true"></i></a></li>
              <li><a href="#"><i class="fa-brands fa-linkedin" aria-hidden="true"></i></a></li>
              <li><a href="#"><i class="fa-brands fa-twitter" aria-hidden="true"></i></a></li>
              <li><a href="#"><i class="fa-brands fa-youtube" aria-hidden="true"></i></a></li>
            </ul>
          </div>
        </div>

        <div class="col-sm-4-custom" data-aos="flip-up">
          <div class="footer-form">
            <h2 class="footer-form-heading">Contact Us</h2>
            <form id="contact" onSubmit="return setAction(contact)">
              <input type="text" class="form-control" id="name" placeholder="Name" required="true">
              <input type="text" class="form-control" id="company" placeholder="Company">
              <input type="email" class="form-control" id="email" placeholder="Email" required="true">
              <input type="phone" class="form-control" id="phone" placeholder="Phone" required="true">
              <input type="text" class="form-control" id="message" placeholder="Message">
              <div class="form-check checkbox-step-3">
                <label class="form-check-label">
                  <input class="form-check-input visitors_chk" type="checkbox" id="agree" required="true">
                  <span></span>
                  <b>I agree to the <a style="color: white; text-decoration: underline;">terms of the privacy
                      policy</a></b>
                </label>
              </div>
              <button class="btn" type="submit">Submit</button>
            </form>
          </div>
        </div>

        <div class="col-sm-4-custom" data-aos="flip-left">
          <div class="address-right">
            <!-- <p class="call">Phone: <a href="tel:+1437826SCAN">{{telephone}}----+1 (437) 826 SCAN</a></p> -->
            <p class="call">
              <ng-container *ngIf="telephone; else defaultTel">
                Phone: <a [href]="'callto:' + telephone">{{ telephone }}</a>
              </ng-container>

              <ng-template #defaultTel>
                Phone: <a href="tel:+1437826SCAN">+1 (437) 826 SCAN</a>
              </ng-template>
            </p>

            <p class="fax">Fax: <a href="fex:+14372531432">+1 (437) 253 1432</a></p>
            <!-- <p class="email">Email: <a href="mailto:Hello@scanfluence.com">{{email}}----Hello@scanfluence.com</a></p> -->
            <p class="email">
              <ng-container *ngIf="email; else defaultEmail">
                Email: <a [href]="'mailto:' + email">{{ email }}</a>
              </ng-container>

              <ng-template #defaultEmail>
                Email: <a href="mailto:Hello@scanfluence.com">Hello@scanfluence.com</a>
              </ng-template>
            </p>
            <!-- <p><span>Address:</span> {{address}}---- 3600 Steeles Avenue East<br>Markham, ON, L3R 9Z7 </p> -->
            <p class="address">
              <ng-container *ngIf="address; else defaultAddress">
                <span>Address:</span><br>
                <a [href]="'https://www.google.com/maps?q=' + address" target="_blank">
                  {{ address }}
                </a>
              </ng-container>

              <ng-template #defaultAddress>
                <span>Address:</span><br>
                <a href="https://www.google.com/maps?q=3600+Steeles+Avenue+East+Markham,+ON+L3R+9Z7" target="_blank">
                  3600 Steeles Avenue East<br>Markham, ON, L3R 9Z7
                </a>
              </ng-template>
            </p>

            <p><span> Authorised channel partner </span> </p>

            <!-- <p class="call">Phone: <a href="tel:+1437826SCAN">+1 (437) 826 SCAN</a></p>
                        <p class="fax">Fax: <a href="fex:+14372531432">+1 (437) 253 1432</a></p>
                        <p class="email">Email: <a href="mailto:Hello@scanfluence.com">Hello@scanfluence.com</a></p>
                        <p><span>Address:</span> 3600 Steeles Avenue East<br>Markham, ON, L3R 9Z7 </p> -->
            <ul class="footer-links">
              <li><a href="about.html">Company</a></li>
              <li><a href="solutions.html">Partner</a></li>
              <li><a href="terms-condition.html" (click)="openTerms($event)">Terms &amp; Conditions</a></li>
            </ul>
            <ul style="margin:0px">
              <li><a href="privacy.html" (click)="openPrivacy($event)">Privacy Policy</a></li>
              <li><a href="cookie.html" (click)="openCookie($event)">Cookie Policy</a></li>
            </ul>
          </div>
        </div>

        <div class="col-sm-12-custom">
          <p class="copy-right" style="padding-top:20px">© 2025 Scanfluence. All rights reserved</p>
        </div>
      </div>
    </div>
  </footer>

</div>

<div class="video-modal" aria-hidden="true" role="dialog" aria-modal="true" aria-label="Video player">
  <div class="video-modal__backdrop" data-close-video></div>
  <div class="video-modal__dialog" role="document">
    <button type="button" class="video-modal__close" data-close-video aria-label="Close video"></button>
    <div class="video-modal__body">
      <iframe class="video-modal__frame" src="" title="Scanfluence video player" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </div>
  </div>
</div>